module.exports = __webpack_public_path__ + "static/media/mutasi_mas.917b2730.png";